<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_documento_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Documentos</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="descripcion" class="col-md-5"
                      >Descripción</label
                    >
                    <input
                      type="text"
                      id="descripcion"
                      v-model="filtros.descripcion"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="tipo_doc" class="col-md-5"
                      >Tipo de Documento</label
                    >
                    <select
                      id="tipo_doc"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_doc"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_doc in listasForms.tipo_docs"
                        :key="tipo_doc.numeracion"
                        :value="tipo_doc.numeracion"
                      >
                        {{ tipo_doc.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="estado" class="col-md-5">Estado</label>
                    <select
                      id="estado"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="descripcion1"
                              v-model="form.descripcion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="descripcion1"
                              >Descripción</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_doc1"
                              v-model="form.tipo_doc"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="tipo_doc1"
                              >Tipo de Documento</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="vencimiento1"
                              v-model="form.vencimiento"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="vencimiento1"
                              >Vencimiento</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="estado1"
                              v-model="form.estado"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="estado1"
                              >Estado</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('argentina.documentos.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "CiudadExport", //llegada tambien
  components: { Loading },
  data() {
    return {
      cargando: false,
      form: {
        descripcion: true,
        tipo_doc: true,
        vencimiento: true,
        estado: true,
      },
      filtros: {
        descripcion: null,
        tipo_doc: null,
        estado: null,
      },

      listasForms: {
        tipo_docs: [],
        estados: [],
      },
    };
  },

  methods: {
    getTiposDocs() {
      axios.get("/api/lista/3").then((response) => {
        this.listasForms.tipo_docs = response.data;
      });
    },

    getEstado() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/argentina/documentos/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getTiposDocs();
    await this.getEstado();
    this.cargando = false;
  },
};
</script>
